// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__FIL-l","footer":"ChangeClinic_footer__2e-zT"};